import { FaTrash } from "react-icons/fa";
import { apiDelete } from "../../API/Api_Url";
import { toast } from "react-toastify";
import { useState } from "react";

function SupplierDeleteQuotationModal({ quotation, isOpen, onClose, setExpandedJob, GetAllPendingMaterialRequest }) {
  console.log(quotation)
  const [IsLoading, setIsLoading] = useState(false);

  const onDelete = async () => {
    try {
      setIsLoading(true);
      const response = await apiDelete(`/api/material-supplier/DeleteMaterialRequestBid/${quotation?._id}`);
      toast.success(response?.message || "quotation deleted successfully!");
      onClose()
      setExpandedJob(null)
      GetAllPendingMaterialRequest();
    } catch (error) {
      console.error("Error updating ServiceRequirement:", error);
      toast.error("Something went wrong. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;


  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl shadow-lg p-6 max-w-md w-full">
        <div className="flex items-center gap-2 mb-4">
          <FaTrash className="text-red-600" />
          <h2 className="text-lg font-bold text-gray-800">Delete Quotation</h2>
        </div>
        <p className="text-sm text-gray-600 mb-6">
          Are you sure you want to delete this quotation? This action cannot be undone.
        </p>
        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-1.5 border rounded hover:bg-gray-100 text-sm"
          >
            Cancel
          </button>
          <button
            onClick={() => onDelete()}
            disabled={IsLoading}
            className="px-4 py-1.5 bg-red-600 text-white rounded hover:bg-red-700 text-sm disabled:opacity-50"
          >
            {IsLoading ? "Deleting..." : "Delete"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default SupplierDeleteQuotationModal